import { Static, Type } from '@sinclair/typebox'

export const AdminMcp = Type.Object({
    id: Type.String(),
    name: Type.String(),
    types: Type.Array(Type.String()),
    pieceNames: Type.Array(Type.String()),
    externalIds: Type.Array(Type.String()),
    externalCustomerId: Type.Union([Type.String(), Type.Null()]),
    tenantId: Type.String(),
})

export type AdminMcp = Static<typeof AdminMcp>

export const ListAdminMcpsRequest = Type.Object({
    cursor: Type.Optional(Type.String()),
    limit: Type.Optional(Type.Number({ default: 20 })),
    search: Type.Optional(Type.String()),
    externalId: Type.Optional(Type.String()),
    externalCustomerId: Type.Optional(Type.String()),
    tenantId: Type.Optional(Type.String()),
    userId: Type.Optional(Type.String()),
})

export type ListAdminMcpsRequest = Static<typeof ListAdminMcpsRequest>
